<template>
    <p>hi</p>
</template>

<script>
export default {
    name: 'Explain_object_test'
}
</script>



// WEBPACK FOOTER //
// src/components/explain_object_test.vue